<svg *ngIf="icon" class="custom-icon" [ngStyle]="{ 'width' : width + 'px', 'height': height + 'px'}">
  <use [attr.xlink:href]="'/assets/icons/v2/' + (file || icon) + '.svg#' + icon"></use>
</svg>
